import { getStoredLang, normalizeLang } from './lang'

/** Tag pools aligned with gyffy.vip `service` / `service_data` style. */
const TAG_POOLS = {
  de: [
    'Oralsex',
    '69',
    'Lippenkuss',
    'Ehefrau',
    'Seeohr',
    'Abalone',
    'heißer Tanz',
    'Umarmen',
    'streicheln',
    'küssen',
    'lutschen',
    'Brustmassage',
    'Masturbation',
    'Ganzkörperlecken',
    'Lolita',
    'Modell',
    'Sekretär',
    'Student',
  ],
  en: [
    'Oral',
    '69',
    'Kiss',
    'Wife',
    'Abalone',
    'Hot dance',
    'Hug',
    'Caress',
    'Suck',
    'Breast massage',
    'Masturbation',
    'Body lick',
    'Lolita',
    'Model',
    'Secretary',
    'Student',
  ],
  fr: [
    'Oral',
    '69',
    'Baiser',
    'Épouse',
    'Danse chaude',
    'Câlin',
    'Caresser',
    'Sucer',
    'Massage',
    'Masturbation',
    'Lolita',
    'Mannequin',
    'Secrétaire',
    'Étudiante',
  ],
  it: [
    'Orale',
    '69',
    'Bacio',
    'Moglie',
    'Ballo caldo',
    'Abbraccio',
    'Carezza',
    'Succhio',
    'Massaggio',
    'Masturbazione',
    'Lolita',
    'Modella',
    'Segretaria',
    'Studentessa',
  ],
  zh: [
    '口交',
    '69',
    '舌吻',
    '人妻',
    '鲍鱼',
    '热舞',
    '拥抱',
    '爱抚',
    '吸吮',
    '胸部按摩',
    '自慰',
    '全身舔',
    '萝莉',
    '模特',
    '秘书',
    '学生',
  ],
}

function hashId(id) {
  const s = String(id == null ? 0 : id)
  let h = 2166136261
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i)
    h = Math.imul(h, 16777619)
  }
  return h >>> 0
}

/**
 * Pick 3 stable tags for a profile (same id + lang => same tags).
 * Mirrors gyffy: service string split into service_data of 3 labels.
 */
export function pickServiceTags(id, lang, count = 3) {
  const l = normalizeLang(lang || getStoredLang())
  const pool = TAG_POOLS[l] || TAG_POOLS.de
  if (!pool.length) return []
  const seed = hashId(`${id}:${l}`)
  const picked = []
  const used = new Set()
  for (let i = 0; i < count; i++) {
    let idx = (seed + i * 17) % pool.length
    let guard = 0
    while (used.has(idx) && guard < pool.length) {
      idx = (idx + 1) % pool.length
      guard++
    }
    used.add(idx)
    picked.push(pool[idx])
  }
  return picked
}

export function parseServiceTags(item, lang) {
  if (item && Array.isArray(item.service_data) && item.service_data.length) {
    return item.service_data.map((t) => String(t).trim()).filter(Boolean).slice(0, 3)
  }
  if (item && item.service) {
    const parts = String(item.service)
      .split(/[,，]/)
      .map((t) => t.trim())
      .filter(Boolean)
    if (parts.length) return parts.slice(0, 3)
  }
  return pickServiceTags(item && item.id, lang, 3)
}
